var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconProfileActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-icon-profile-active",
    transform: "translate(-140 -241)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5668",
    "data-name": "Rectangle 5668",
    width: 34,
    height: 34,
    transform: "translate(140 241)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6979",
    "data-name": "Group 6979",
    transform: "translate(115.089 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(-3564.505 -151.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M26.182,142.852a8.273,8.273,0,1,1-8.274-8.272h0A8.271,8.271,0,0,1,26.182,142.852Z",
    transform: "translate(3589 409)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M23.89,154.3H11.784a6.368,6.368,0,0,0-6.368,6.368v.583A2.185,2.185,0,0,0,7.6,163.432H28.075a2.183,2.183,0,0,0,2.183-2.183v-.583A6.368,6.368,0,0,0,23.89,154.3Z",
    transform: "translate(3589 409)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconProfileActive);
export default __webpack_public_path__ + "static/media/nav-icon-profile-active.63e0a11f7143a0e9810a518bc3c35665.svg";
export { ForwardRef as ReactComponent };